/* Shoppable pins for the shop-the-look section.
   ==================================================================
   Hover alone is not enough. It excludes keyboards entirely, and on a touch screen the first
   tap on a hover-only control is swallowed as a hover, so the card opens and the link under it
   fires on the same gesture. So hover is CSS, and this handles click, keyboard and Escape.

   Delegated from the document, because these sections are re-rendered whole by the theme
   editor whenever a setting changes: binding per pin would leave dead handlers behind. */
(function () {
  'use strict';

  /* Bind once, however many sections ask for this file.
     Each shop-the-look section with pins emits its own script tag, so with two such sections on
     a page the listeners were registered twice and every click ran both: the first opened the
     card, the second closed it, and nothing appeared to happen. The tag stays per-section
     because a section has no way to know what else is on the page; the guard lives here. */
  if (window.__faHotspotsBound) return;
  window.__faHotspotsBound = true;

  var OPEN = 'is-open';

  function close(hotspot) {
    if (!hotspot) return;
    hotspot.classList.remove(OPEN);
    var dot = hotspot.querySelector('.fa-hotspot__dot');
    if (dot) dot.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.fa-hotspot.' + OPEN).forEach(function (h) {
      if (h !== except) close(h);
    });
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.fa-hotspot__dot');

    if (dot) {
      var hotspot = dot.closest('.fa-hotspot');
      var isOpen = hotspot.classList.contains(OPEN);
      // one card at a time: two cards open at once overlap each other on a busy photograph
      closeAll(hotspot);
      hotspot.classList.toggle(OPEN, !isOpen);
      dot.setAttribute('aria-expanded', String(!isOpen));
      e.preventDefault();
      return;
    }

    // a click inside a card is a real click on the product link, so leave it alone
    if (e.target.closest && e.target.closest('.fa-hotspot__card')) return;

    closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.fa-hotspot.' + OPEN);
    if (!open) return;
    var dot = open.querySelector('.fa-hotspot__dot');
    close(open);
    if (dot) dot.focus();   // send focus back to the control that opened it
  });

  // Tabbing away from a pin closes it, so a keyboard user is not left with a card open behind
  // them. focusout rather than blur because blur does not bubble.
  document.addEventListener('focusout', function (e) {
    var hotspot = e.target.closest && e.target.closest('.fa-hotspot');
    if (!hotspot || !hotspot.classList.contains(OPEN)) return;
    setTimeout(function () {
      if (!hotspot.contains(document.activeElement)) close(hotspot);
    }, 0);
  });
})();
